import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Loader2, Lock } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { useAuth, formatApiError } from '../../admin/AuthContext';

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={location.state?.from || '/admin'} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await login(email.trim(), password);
      navigate(location.state?.from || '/admin', { replace: true });
    } catch (err) {
      setError(formatApiError(err, 'Login failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#2A0F14] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="https://customer-assets.emergentagent.com/job_vbglobal-portal/artifacts/k1dc2y0l_VB%20GLOBAL%20LOGO.jpg" alt="VB Global" className="h-24 mx-auto rounded-lg bg-white p-2" />
          <h1 className="text-2xl font-bold text-white mt-6">Admin Login</h1>
          <p className="text-sm text-gray-300 mt-1">Manage blog articles for vbglobal.in</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-2xl p-8 space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label htmlFor="admin-email">Email</Label>
            <Input id="admin-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="username" data-testid="admin-login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password">Password</Label>
            <Input id="admin-password" type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" data-testid="admin-login-password" />
          </div>
          {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="w-full bg-[#8B2C3A] hover:bg-[#6B1C2A] text-white" data-testid="admin-login-submit">
            {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Lock className="w-4 h-4 mr-2" />}
            Sign in
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
